import type { MouseEvent } from "react";
import { memo, useCallback } from "react";

import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

type NumberInputSignToggleAdornmentProps = {
  onToggle: () => void;
  disabled?: boolean;
};

const NumberInputSignToggleAdornment = ({
  onToggle,
  disabled = false,
}: NumberInputSignToggleAdornmentProps) => {
  const { t } = useTranslation("common");

  // prevent the input from blurring when tapping the toggle, so the typing session stays alive
  const handleMouseDown = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  }, []);

  return (
    <InputAdornment position="end" disableTypography sx={{ mr: 0.5 }}>
      <Tooltip title={t("common:toggle_sign")}>
        <span>
          <IconButton
            size="small"
            onClick={onToggle}
            onMouseDown={handleMouseDown}
            disabled={disabled}
            aria-label={t("common:toggle_sign")}
            sx={{ fontSize: "1rem", fontWeight: 600, px: 0.5 }}
          >
            ±
          </IconButton>
        </span>
      </Tooltip>
    </InputAdornment>
  );
};

export default memo(NumberInputSignToggleAdornment);
